import React, { useEffect } from 'react';


export default function IC_item_model({ data, entity, setDataKeyValue }) {

    // Calcolo volume automatico
    useEffect(() => {
        const volume = (parseInt(data.depth) / 100) * (parseInt(data.length) / 100) * (parseInt(data.height) / 100);
        if (parseFloat(data.volume).toFixed(2) !== parseFloat(volume).toFixed(2)) {
            setDataKeyValue('volume', parseFloat(volume).toFixed(2))
        }
    }, [data]);

    // Se type = 30_PRODOTTI_VENDITA, imposta picking a 1
    useEffect(() => {
        if (data.type.value === '30_PRODOTTI_VENDITA') {
            if (data.picking !== 1 && data.picking !== true) {
                setDataKeyValue('picking', 1);
            }
        } else {
            if (data.picking !== 0 && data.picking !== false) {
                setDataKeyValue('picking', 0);
            }
        }
    }, [data.type]);

    // Disabilita i campi dimensionali se picking è abilitato
    useEffect(() => {
        if (data.picking === 1 || data.picking === true) {
            const fieldsToDisable = [
                '#item_model_field_length input',
                '#item_model_field_depth input',
                '#item_model_field_height input',
                '#item_model_field_grossWeight input',
                '#item_model_field_volume input',
                '#item_model_field_packages input'
            ];
            fieldsToDisable.forEach(selector => {
                const field = document.querySelector(selector);
                if (field) {
                    field.disabled = true;
                    field.style.backgroundColor = '#e9ecef';
                }
            });
        } else {
            const fieldsToEnable = [
                '#item_model_field_length input',
                '#item_model_field_depth input',
                '#item_model_field_height input',
                '#item_model_field_grossWeight input',
                '#item_model_field_volume input',
                '#item_model_field_packages input'
            ];
            fieldsToEnable.forEach(selector => {
                const field = document.querySelector(selector);
                if (field) {
                    field.disabled = false;
                    field.style.backgroundColor = '';
                }
            });
        }
    }, [entity, data.picking]);

    return (
        <></>
    )
};
